import React, { useContext, useEffect, useState } from "react";
import { FormGroup, FormLabel } from "react-bootstrap";
import FormSelectField from "../../Components/FormSelectField";
import { Field, Formik } from "formik";
import Account from "../../Services/accountServices";
import { AuthContext } from "../../Auth/Context/AuthContext";
import { message } from "antd";
import Loader from "../../Components/Loader";
import { addAccountSchemaValidation } from "../../config/Validations";
import TitleHeader from "./Components/TitleHeader";
import { NavLink } from "react-router-dom";
function AddAccount(props) {
  const { user } = useContext(AuthContext);
  const [accountTypes, setAccountTypes] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const [fieldError, setFieldError] = useState();
  const [accounts, setAccounts] = useState([]);

  const fetchAccounts = async () => {
    await Account.getAllAccounts().then((acc) => {
      setAccounts(acc.data);
    });
  };
  const addAccount = async (formValues, { resetForm }) => {
    if (!formValues.parentId && !formValues.accountType) {
      return setFieldError("Field is Required");
    }
    if (!formValues.parentId && !formValues.currency) {
      return setFieldError("Field is Required");
    }
    setFieldError(null);
    setIsloading(true);
    const data = {
      name: formValues.name,
      note: formValues.note,
      currencyId: parseInt(formValues.currency),
      currencyName: currencies.find(
        (op) => op.id === parseInt(formValues.currency)
      )?.name,
      accountTypeId: parseInt(formValues.accountType),
      accountTypeName: accountTypes.find(
        (op) => op.id === parseInt(formValues.accountType)
      )?.name,
      branchId: user.branchId,
      parentId: parseInt(formValues.parentId),
      parentName: accounts.find((op) => op.id === parseInt(formValues.parentId))
        ?.name,
      code: formValues.code,
    };
    if (formValues.parentId) {
      const acc = accounts.find(
        (op) => op.id === parseInt(formValues.parentId)
      );
      data.accountTypeId = acc.accountTypeId;
      data.accountTypeName = acc.accountTypeName;
      data.currencyId = acc.currencyId;
      data.currencyName = acc.currencyName;
    }

    await Account.createAccount(data)
      .then((response) => {
        console.log("ACCOUNT CREATED", response);
        if (response.data) {
          setIsloading(false);
          resetForm();
          return message.success("Account Created Successfully");
        }
      })
      .catch((err) => {
        message.error("Failed to Create Account");
        setIsloading(false);
      });
  };

  const fetchAccountTypes = async () => {
    Account.getAccountTypes().then((types) => {
      setAccountTypes(types.data);
    });
  };
  const fetchCurrencies = async () => {
    Account.getActivatedCurrencies().then((curr) => {
      setCurrencies(curr.data);
    });
  };
  useEffect(() => {
    fetchAccounts();
    fetchAccountTypes();
    fetchCurrencies();
  }, []);

  return (
    <>
      {isLoading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div className="page-wrapper">
        <div className="content">
          <TitleHeader title="Chart of Accounts - Create New Account" />

          <div className="card">
            <div className="card-body">
              <div className="row">
                <Formik
                  enableReinitialize
                  initialValues={{
                    name: "",
                    accountType: "",
                    currency: "",
                    code: "",
                    note: "",
                    parentId: "",
                  }}
                  onSubmit={addAccount}
                  validationSchema={addAccountSchemaValidation}
                >
                  {({
                    errors,
                    touched,
                    values,
                    setFieldValue,
                    handleSubmit,
                  }) => (
                    <>
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="form-group">
                          <FormGroup>
                            <FormLabel>
                              Account Name
                              <span style={{ color: "red" }}>*</span>
                            </FormLabel>
                            <Field type="text" name="name" required />
                            {errors.name && touched.name && (
                              <p style={{ color: "red" }}>{errors.name}</p>
                            )}
                          </FormGroup>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="form-group">
                          <FormGroup>
                            <FormLabel>
                              Account Number
                              <span style={{ color: "red" }}>*</span>
                            </FormLabel>
                            <Field
                              type="number"
                              className="form-control"
                              name="code"
                            />
                            {errors.code && touched.code && (
                              <p style={{ color: "red" }}>{errors.code}</p>
                            )}
                          </FormGroup>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Sub Account Of</FormLabel>
                          <FormSelectField
                            type="select"
                            name="parentId"
                            setFieldValue={setFieldValue}
                          >
                            <option value="">Select</option>
                            {accounts &&
                              accounts.map((type) => (
                                <option value={type.id}>{type.name}</option>
                              ))}
                          </FormSelectField>
                        </div>
                      </div>
                      {!values.parentId && (
                        <>
                          <div className="col-lg-3 col-sm-6 col-12">
                            <div className="form-group">
                              <FormLabel>
                                Account Type
                                <span style={{ color: "red" }}>*</span>
                              </FormLabel>
                              <FormSelectField
                                type="select"
                                name="accountType"
                                setFieldValue={setFieldValue}
                              >
                                <option value="">Select</option>
                                {accountTypes &&
                                  accountTypes.map((type) => (
                                    <option value={type.id}>
                                      {type.name}-({type.type})
                                    </option>
                                  ))}
                              </FormSelectField>

                              {fieldError && touched.accountType && (
                                <p style={{ color: "red" }}>{fieldError}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-6 col-12">
                            <div className="form-group">
                              <FormLabel>
                                Currency<span style={{ color: "red" }}>*</span>
                              </FormLabel>
                              <FormSelectField
                                type="select"
                                name="currency"
                                setFieldValue={setFieldValue}
                              >
                                <option value="">Select</option>
                                {currencies &&
                                  currencies.map((type) => (
                                    <option value={type.id}>{type.name}</option>
                                  ))}
                              </FormSelectField>

                              {fieldError && touched.currency && (
                                <p style={{ color: "red" }}>{fieldError}</p>
                              )}
                            </div>
                          </div>
                        </>
                      )}

                      <div className="col-lg-9">
                        <div className="form-group">
                          <FormGroup>
                            <FormLabel>Note</FormLabel>
                            <Field
                              type="text"
                              className="form-control"
                              name="note"
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <a
                          href="#"
                          className="btn btn-submit me-2"
                          onClick={handleSubmit}
                        >
                          Save
                        </a>
                        <NavLink to="/accounts-list" className="btn btn-cancel">
                          Cancel
                        </NavLink>
                      </div>
                    </>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddAccount;
